import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild } from '@angular/core';
import { Usuario } from '../../shared/index';
import { LoginService } from '../../shared/service/login/login.service';
import { TokenService } from '../../shared/service/token/token.service';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';

declare var $: any;

@Component({
  selector: 'app-cadastro-token-otp',
  templateUrl: './cadastro-token-otp.component.html',
  styleUrls: ['./cadastro-token-otp.component.css']
})
export class CadastroTokenOtpComponent implements OnInit {

    @Input() statusFatores: any = {};
    @Output() tokenCadastrado = new EventEmitter<boolean>();
    @Output() enviaMensagemSucesso = new EventEmitter();
    public passo: string = "ESCOLHA_TIPO";
    public requisicaoTokenOtpEnviada: boolean = false;
    public tokenErrorMessage: string = "";
    public usuario : Usuario;
    public eTokenName : string = "";
    public senhaTemporaria: string = "";
    public qrCodeValue: string = "vazio";
    public requisicaoCartao: any = {};
    public tresPontinhos: string;
    private codigoRequisicaoToken: string;
    private timerTresPontinhos: any;
    private timerConclusaoInit: any;
    public redefinicaoErrorMessage: string;
    public resetObject: any = {};
    public tipoToken: string;
    public urlProxy: string = "";
  
    @ViewChild('formOTP', {static: true}) formOTP;

    constructor(
        private tokenService : TokenService,
        private loginService : LoginService,
        private usuarioService : UsuarioService,
        ) {
    }

    ngOnInit() {
        this.usuario = JSON.parse(localStorage.getItem("currentUser"));
        this.urlProxy = this.usuario.urlProxy
    }


    exibirFormCartao() {
        this.passo = "REQUISITA_DADO_CARTAO";
    }

    exibirFormMobileid() {
        this.passo = "REQUISITA_PIN";
        this.tipoToken = "MOBILEID";
    }

    exibirFormServidor() {
        this.passo = "REQUISITA_PIN";
        this.tipoToken = "SERVIDOR";
    }


    generateTempPassword() {
        if (this.requisicaoTokenOtpEnviada) {
            return;
        }
        
        this.tokenErrorMessage = null;

        let idUsuario =  this.usuario.id;
        let idOrganizacao = this.usuario.organizacaoId;
        let pinDigitado = this.usuario.senha;
        let eTokenName = this.eTokenName;
        this.tokenService.gereSenhaTemporaria(idUsuario, idOrganizacao, pinDigitado,eTokenName,this.tipoToken).subscribe(
            res => {
                this.senhaTemporaria =  res.senhaTemporaria;
                this.qrCodeValue =  JSON.stringify({eTokenSenha : res.senhaTemporaria});
                this.codigoRequisicaoToken = res.codigoRequisicao;

                this.registraTimerConclusao();

                this.usuario.senha = null;

                if (this.tipoToken == "MOBILEID") {
                    this.passo = "EXIBE_SENHA_PROV";
                } else {
                    this.passo = "EXIBE_SENHA_PROV_SERVIDOR";
                }
                
                this.requisicaoTokenOtpEnviada = true;
            },
            err => {
                this.tokenErrorMessage = err.message;
                this.requisicaoTokenOtpEnviada = false;
                this.resetOtp(false);
                if (err.status === 401 || err.status === 403){
                    this.loginService.logout();
                }
            }
        );

        if (this.timerTresPontinhos) {
            clearInterval(this.timerTresPontinhos);
        }
        this.timerTresPontinhos = setInterval(() => {
            let possibilidades: string[] = ["", ".", "..", "..."];
            let index =  Math.floor(new Date().getTime() / 500) % possibilidades.length;
            this.tresPontinhos = possibilidades[index];
        }, 500);
    }

    registraTimerConclusao() {
        let idUsuario =  this.usuario.id;
        this.timerConclusaoInit = setInterval(() => {
            this.tokenService.inicializacaoConcluida(this.codigoRequisicaoToken, idUsuario).subscribe(
                res => {
                    if (res.concluida) {
                        this.resetOtp(false);
                        this.passo = 'MOSTRA_CONCLUIDO';
                        this.tokenCadastrado.emit(true);
                        this.requisicaoTokenOtpEnviada = false;
                    }

                    if (res.solicitacaoFalhou) {
                        this.resetOtp(false);
                        this.tokenErrorMessage = res.mensagemFalha;
                    }
                },
                err => {
                     this.tokenErrorMessage = err.message;
                }
            );
        }, 2000);
    }

    geraTokenCartao() {
        let idUsuario =  this.usuario.id;
        let idOrganizacao = this.usuario.organizacaoId;

        this.tokenService.geraTokenCartao(idUsuario, idOrganizacao, this.requisicaoCartao).subscribe(
            res => {
                if (res.concluida) {
                    this.resetOtp(false);
                    this.passo = 'MOSTRA_CONCLUIDO';
                    this.tokenCadastrado.emit(true);
                    this.requisicaoTokenOtpEnviada = false;
                }
            },
            err => {
                this.tokenErrorMessage = err.message;
            }
        );
    }

    resetOtp(closeModal: boolean) {
        this.senhaTemporaria = "";
        this.qrCodeValue = "vazio";
        clearInterval(this.timerTresPontinhos);
        clearInterval(this.timerConclusaoInit);
        if (closeModal) {
            $('#modalCadastrarToken').modal("hide");
            this.resetForm();
        }
    }

    selecionouRedefinirCartao() {
        this.passo = "REDEFINIR_OTP";
        this.resetObject.tipo = "CARTAO";
    }

    selecionouRedefinirMobile() {
        this.passo = "REDEFINIR_OTP";
        this.resetObject.tipo = "MOBILEID";
    }

    enviaEmailRedefinirOTP() {
        this.usuarioService.enviarEmailRedefinicaoOTP(this.usuario.id, this.usuario.organizacaoId, this.resetObject).subscribe(
            res => {
                this.resetarCampos();
                this.mensagemSucesso("Um e-mail foi enviado com instruções para a redefinição do e-Token.");
                $('#modalCadastrarToken').modal('hide');
            },
            err => {
                this.redefinicaoErrorMessage = err.message;
            }
      );
      this.resetObject.pinAtual = null;
    }

    resetarCampos(){
        this.usuario.senha = null;
        this.tokenErrorMessage = null;
        this.redefinicaoErrorMessage = null;
        this.passo = "ESCOLHA_TIPO";
        this.eTokenName = "";
        this.formOTP.resetForm();
    }

    resetForm() {
        /*
        if (this.tourService.getStatus() == TourState.ON) {
            this.tourService.goto(this.tourService.currentStep.stepId);
        }
        */
        this.resetarCampos();
    }

    eTokenCadastrado(){
        /*
        if (this.tourService.getStatus() == TourState.ON) {
            this.tourService.next();
        }
        */
        
        this.resetarCampos();
    }

    fechaJanela() {
        /*
        if (this.tourService.getStatus() == TourState.ON) {
            this.tourService.goto(this.tourService.currentStep.stepId);
        }
        */
        
        $('#modalCadastrarToken').modal('hide');
    }

    mensagemSucesso(mensagem : string){
        this.enviaMensagemSucesso.emit(mensagem);
    }
}
